import {Box} from '@mui/material';
import {t} from 'i18next';
import {useDispatch, useSelector} from 'react-redux';
import {setDialogReportName} from '../../../redux/slices/reportsDialogSlice';
import HostingUserSummaryReportDetails from './HostingUserSummaryReportDetails';
import HostingUserSummaryReportHeader from './HostingUserSummaryReportHeaders';
import HostingUserSummaryReportTable from './HostingUserSummaryReportTable';
import {RootState} from '../../../redux/store';

const HostingUserSummaryReportPage = () => {
  const dispatch = useDispatch();
  const refreshDates = useSelector(
    (state: RootState) => state.reports.refreshDates
  );
  dispatch(
    setDialogReportName(t('reports.projectOverview.tabs.tabHostingUserSummary'))
  );
  return (
    <Box>
      <HostingUserSummaryReportHeader
        refreshDate={refreshDates.hostingUserSummary}
        openFrom={t('reports.projectOverview.tabs.tabHostingUserSummary')}
      />
      <HostingUserSummaryReportDetails />
      <HostingUserSummaryReportTable />
    </Box>
  );
};

export default HostingUserSummaryReportPage;
